import React, {useMemo, useEffect} from 'react';
import {Link} from 'react-router-dom';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Table, Popup} from 'semantic-ui-react';
import {Filter, DefaultColumnFilter} from '../common/TableFilters';
import CampaignViewIcon from '../common/icons/CampaignViewIcon';
import TablePaginator from '../common/TablePaginator';

const columnsTableWithProps = (isUserTde) => {
  return [
    {
      'Header': 'CAMPAÑA',
      'disableFilters': true,
      'columns': [
        {
          'Header': 'CHASIS',
          'accessor': 'chassis',
        },
        {
          'Header': 'CÓDIGO SSC',
          'accessor': 'sscCode',
        },
        {
          'Header': 'NÚMERO CAMPAÑA',
          'accessor': 'campaingNo',
        },
        {
          'Header': 'NOMBRE CAMPAÑA',
          'accessor': 'campaingName',
        },
        {
          'id': 'accion campaña',
          'Header': 'ACCIÓN',
          'Cell': ({row}) => {
            const {campaingNo} = row.original;
            return (
              <CampaignViewIcon campaingNo={campaingNo} isUserTde={isUserTde} />
            );
          },
        },
      ],
    },
    {
      'Header': 'GARANTÍA',
      'disableFilters': true,
      'columns': [
        {
          'Header': 'DEALER ID',
          'accessor': 'numTwcDealer',
        },
        {
          'Header': 'DEALER',
          'accessor': 'dealer',
        },
        {
          'Header': 'NÚMERO GARANTÍA',
          'accessor': 'numTwc',
        },
        {
          'Header': 'ESTADO TWC',
          'accessor': 'twcStatusDescription',
        },
        {
          'Header': 'FECHA TWC',
          'accessor': 'dateTwc',
        },
        {
          'id': 'accion garantia',
          'Header': 'ACCIÓN',
          'disableFilters': true,
          'Cell': ({row}) => {
            const {numTwc, dealerId, numTwcDealer} = row.original;
            return (
              <Popup
                trigger={
                  <Link
                    to={`/editar-garantias/${numTwc}/${numTwcDealer}/${dealerId}`}
                    target='_blank'
                  >
                    <span className='link'>
                      <i className='material-icons'>
                        visibility
                      </i>
                    </span>
                  </Link>
                }
                content='Ver Garantia'
                position='top center'
                inverted
              />
            );
          },
        },
      ],
    },
  ];
};

const getRowValue = (row) => {
  const worked = (row.original && row.original.numTwc);
  if (!worked) {
    return {
      'style': {
        'color': '#9f3a38',
        'background': '#fff6f6',
      },
    };
  }
  
  return {
    'style': {
      'color': '#576a08',
      'background': '#f1fff1',
    },
  };
};

const CampaignByChassisTable = ({loading, dataTable, handleChange, isUserTde, countRows}) => {
  const columnsTable = columnsTableWithProps(loading, isUserTde);
  const data = useMemo(() => dataTable, []);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    rows,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
    },
    useFilters,
    usePagination,
    useRowSelect,
  );

  useEffect(() => {
    if (rows.length !== countRows) {
      handleChange('countRows', rows.length);
    }
  }, [rows]);

  return (
    <>
      <div className='table-container'>
        <Table className='interactive' striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign='center'
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key='filters' id='filters'>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell key={`filter-${index}`} textAlign='center'>
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign='center'>
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i} {...row.getRowProps(getRowValue(row))}>
                    {row.cells.map((cell, j) => {
                      return (
                        <Table.Cell
                          key={j}
                          textAlign='center'
                          disabled={
                            cell.column.id === 'accion garantia' &&
                            (!row.original.numTwc || !isUserTde)
                          }
                        >
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePaginator
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default CampaignByChassisTable;
